import { bootstrap } from "./bootstrapper";

import { module as tarifCovid } from "@/@modules/tarif-covid";
import { module as dcm } from "@/@modules/dcm";

bootstrap(tarifCovid, dcm);
